<template>
  <div v-if="mainConfig.showLatestBids" class="ta-lot-latest-bids card">
    <table class="table table-sm table-bordered mb-0">
      <thead class="table-title">
      <tr>
        <th :colspan="4 + customerAdditionalColumns.length" >
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ $t("Latest Bids") }}</span>
            <a href="javascript:void(0)" v-b-modal.latestBidsModal>{{ $t('View All') }} ({{ lot.num_of_bids }})</a>
          </div>
        </th>
      </tr>
      </thead>
      <thead class="table-headings">
      <tr>
        <th class="col-auto">{{ $t('Auto') }}</th>
        <th class="col-number">{{ $t('Number') }}</th>
        <th v-for="key of customerAdditionalColumns" :key="key"
            :class="'col-customer_' + key">
          {{ $t('latestBids.customer_' + key) }}
        </th>
        <th class="col-amount">{{ $t('Amount') }}</th>
        <th class="col-date">{{ $t('Date/Time') }}</th>
      </tr>
      </thead>
      <tbody v-if="latestBids && latestBids.length">
      <tr v-for="bid in latestBids" :key="bid.id"
          :class="bid.customer_uuid === customer.uuid ? 'font-weight-bold' : ''">
        <td class="col-auto" >{{ bid.auto_bid ? 'A' : '-' }}</td>
        <td class="col-number">{{ bid.paddle_no }}{{ bid.customer_uuid === customer.uuid ? ' (' + $t('me') + ')' : ''}}</td>
        <td v-for="key of customerAdditionalColumns" :key="key" :class="'col-customer_' + key">
          {{ bid['customer_' + key] }}
        </td>
        <td class="col-amount">{{ bid.amount | asCurrency(lot.currency.code) }}</td>
        <td class="col-date">{{ (bid.bid_date || bid.created_at) | datetimeWithSeconds }}</td>
      </tr>
      <tr>
        <td :colspan="4 + customerAdditionalColumns.length" class="text-muted text-left">
          A - {{ $t('Automatic bid placed through Max Bid') }}
        </td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr>
        <td :colspan="4 + customerAdditionalColumns.length" class="text-muted text-center py-3">
          {{ $t('There are no bids on this lot') }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import lotBiddingMixin from "../../mixins/lotBiddingMixin";
import LatestBidsModal from "@/components/lot-view/LatestBidsModal";

export default {
  name: "LatestBids",
  components: {LatestBidsModal},
  mixins: [lotBiddingMixin],
  data: () => ({
    modalShow: false,
  }),
  computed: {
    ...mapState(['mainConfig', 'settings', 'customer']),
    ...mapState({
      lot: state => state.lotObject.data
    }),
    ...mapGetters(['customerAdditionalColumns']),
    latestBids() {
      return this.lot.last_bids ? this.lot.last_bids.slice(0, 5) : []
    }
  }
}
</script>

<style scoped lang="scss">
.ta-lot-latest-bids {
  font-size: 90%;
  overflow-x: auto;
}
</style>

<style lang="scss">
@import "../../scss/mixins";

</style>
